import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'brn-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
})
export class ExpansionPanelComponent implements OnInit {
  @Input() items: string[] = [];
  @Input() currentValue: string = '';
  @Input() showtoolTipFrom: number = 0;
  @Input() shadow: boolean = false;
  @Output() onSelected: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('panelItems') panel?: ElementRef;
  heightItem: number = 0;
  openMenu: boolean = false;

  constructor() {}

  ngOnInit(): void {
    setInterval(() => {
      this.calcHeight();
    }, 1000);
  }

  calcHeight() {
    if (this.items.length) {
      let elements = this.panel?.nativeElement.getElementsByTagName('div');
      this.heightItem = 0;
      for (const el of elements) {
        this.heightItem += el.clientHeight + 6;
      }
    }
  }

  setItem(item: string) {
    this.currentValue = item;
    this.openMenu = false;
    this.onSelected.emit(item);
  }
}
